/**
 * What the App Store says about each app, beyond the catalog: its text lives in
 * `appStorePage.apps.<id>` in the translations, this holds the rest of Figma's "Store · App"
 * pages. `category` picks the store's filter, `meetCategory` the longer label some cards use,
 * `facts` the Good to know rows and `features` the icons of What you can do.
 */
const SHOWS = "shows";
const WHO = "who";
const SELL = "sell";
const STATUS = "status";
const COSTS = "costs";

export const APP_STORE_PAGES = {
  gateway: { category: "sell", sells: true, features: ["link", "lock", "refresh"], facts: [SHOWS, WHO, SELL] },
  courses: { category: "teach", sells: true, features: ["book", "clock", "check-circle"], facts: [SHOWS, WHO, SELL] },
  "mintly-cloud": { category: "sell", sells: true, features: ["cloud", "wallet", "users"], facts: [SHOWS, WHO, SELL] },
  consulting: {
    category: "teach",
    meetCategory: true,
    sells: true,
    features: ["calendar", "headset", "wallet"],
    facts: [SHOWS, WHO, SELL],
  },
  "live-stream": {
    category: "teach",
    meetCategory: true,
    sells: true,
    features: ["broadcast", "wallet", "message"],
    facts: [SHOWS, WHO, SELL],
  },
  "creator-rewards": {
    category: "grow",
    sells: false,
    features: ["megaphone", "check-circle", "chart"],
    facts: [SHOWS, WHO, COSTS],
  },
  shop: { category: "sell", sells: true, features: ["bag", "wallet", "refresh"], facts: [SHOWS, STATUS, SELL] },
  chat: { category: "grow", sells: false, features: ["message", "pin", "users"], facts: [SHOWS, STATUS, WHO] },
};

/** Figma's order on the store's grid. */
export const APP_STORE_ORDER = Object.keys(APP_STORE_PAGES);

/** Worth suggesting to a space, best first. Whichever it hasn't added yet come up. */
export const SUGGESTION_ORDER = ["consulting", "live-stream", "mintly-cloud", "courses", "gateway"];

export const CATEGORY_KEYS = { sell: "catSell", teach: "catTeach", grow: "catGrow" };

/** Consulting: one per space, so an added one can only be opened. Same on the server. */
export const SINGLE_COPY_APP_IDS = ["consulting", "creator-rewards"];
